(function ($, Cobalt, undefined) {
    Cobalt.Feedback = {
        _thankyouTitle: "",
        _thankyouText: "",
        _submitText: "",
        initialize: function () {

            // POSITION
            var $feedbackBlock = $("#site-feedback-block");

            if ($feedbackBlock.length > 0) {
                $feedbackBlock.css('visibility', 'visible');
            }

            Cobalt.Feedback.hookFeedback();
        },
        hookFeedback: function () {


            $("body").on("click", ".j-feedback, .j-feedback-tab", function (e) {
                e.preventDefault();
                var $that = $(this);

                var formTitle = $that.data("form-title") || "Send Us Feedback";                
                var width = $that.data("max-width") || 500;

                var fieldDescription = $that.data("field-description");
                var modalClass = $that.data("modal-class") || "";

                Cobalt.Feedback._thankyouTitle = $that.data("thankyou-title") || "Thank you for Feedback";
                Cobalt.Feedback._thankyouText = $that.data("thankyou-text") || "Thanks for the feedback!";
                Cobalt.Feedback._submitText = $that.data("submit-text") || "Submit Feedback";
                
                $.get(Cobalt.Routes.Instance.FeedbackSend(), function (data) {
                    if (data) {
                        var jsonData = $.parseJSON(data);
                        if (jsonData.html) {
                            var $feedbackDialog = $(jsonData.html);

                            Cobalt.triggerHtmlInsert($feedbackDialog);                            

                            if (fieldDescription) {
                                var descriptionText = $feedbackDialog.find("#form-field-description label span");
                                descriptionText.text(fieldDescription);
                            }

                            $feedbackDialog.find(".j-submit-field > span").text(Cobalt.Feedback._submitText);

                            $feedbackDialog.dialog({
                                dialogClass: modalClass,
                                title: formTitle,                                
                                width: width,
                                close: function (event, ui) {
                                    $feedbackDialog.dialog("destroy");
                                    $feedbackDialog.remove();
                                }
                            });

                            Cobalt.Feedback.handleFeedbackForm();
                        }
                    }
                });
            });
        },
        handleFeedbackForm: function () {

            var $feedbackModal = $("#feedback-form");
            if ($feedbackModal.length > 0) {

                var $feedbackForm = $feedbackModal.find("form");
                $feedbackForm.ajaxForm({
                    success: function (data) {
                        if (data) {
                            var jsonData = $.parseJSON(data);

                            if (jsonData.hasErrors) {
                                var $errorElement = $feedbackModal.find(".errors");
                                $errorElement.text(jsonData.errors.join(','));
                            } else {
                                var $html = $(jsonData.html);
                                $html.find(".j-feedback-thankyou-text").text(Cobalt.Feedback._thankyouText);

                                $feedbackModal.empty();
                                $feedbackModal.append($html);

                                $("#ui-dialog-title-feedback-form").text(Cobalt.Feedback._thankyouTitle);

                                var $close = $feedbackModal.find("a.j-feedback-close");

                                if ($close.length > 0) {
                                    $close.on("click", function (e) {
                                        e.preventDefault();

                                        $("#feedback-form").parent().find("a.ui-dialog-titlebar-close")
                                            .click();
                                    });
                                }
                            }
                        }
                    },
                    error: function (data) {
                        if (data) {
                            var $errorElement = $feedbackModal.find(".errors");
                            $errorElement.text("An unknown error has occurred.");
                        }
                    }
                });

            }

        }
    };

})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Feedback.js